module.exports = __webpack_public_path__ + "img/shortform-desktop.7225b2f6.png";